import axios from 'axios';
import { SERVER_URL } from 'Constants';
import { AbortSignals } from 'Hooks/useAbortSignals';
import { IUser } from 'Views/Components/CRUD/UserList';
import { Conditions, OrderBy } from 'Util/QueryHelpers';

export interface AllUsersResponse {
	countUsers: number;
	users: IUser[];
}

export interface PaginationOptions {
	PageNo: number,
	PageSize: number,
}

export const getAllUsers = (
	abortSignals: AbortSignals,
	paginationOptions: PaginationOptions,
	searchParams: Conditions,
	sortParams: OrderBy,
) => {
	return axios.post<AllUsersResponse>(
		`${SERVER_URL}/api/account/users`,
		{
			PaginationOptions: paginationOptions,
			SearchConditions: searchParams,
			SortConditions: sortParams,
		},
		{
			cancelToken: abortSignals.axiosCancelToken.token,
		},
	);
};

export const deactivateUserRequest = (username: string) => {
	return axios.post<void>(
		`${SERVER_URL}/api/account/deactivate`,
		{
			username: username,
		},
		{
			cancelToken: axios.CancelToken.source().token,
		},
	);
};

export const activateUserRequest = (username: string) => {
	return axios.post<void>(
		`${SERVER_URL}/api/account/activate`,
		{
			Username: username,
		},
		{
			cancelToken: axios.CancelToken.source().token,
		},
	);
};
